var map = {
	"./Dropbox_Icon.svg": "bdee",
	"./add_upload_icon.svg": "dbd9",
	"./arrow_categories.svg": "891b",
	"./arrow_filter_search_bar.svg": "75c4",
	"./arrow_filter_side_bar.svg": "41ac",
	"./arrow_main_filter.svg": "a50d",
	"./arrow_next_page.svg": "1ebc",
	"./attach-icon.svg": "330d",
	"./attention-icon.svg": "833f",
	"./attention-sign.svg": "d17e",
	"./calendar_blue.svg": "69fb",
	"./calendar_grey.svg": "b824",
	"./check.svg": "51c7",
	"./check_role.svg": "9542",
	"./classe_upload_icon.svg": "4e2d",
	"./classificationIcons/skills_icon.svg": "e734",
	"./classificationIcons/time_icon.svg": "15e1",
	"./classificationIcons/topic_icon.svg": "b8fb",
	"./classificationIcons/youtube_file_icon.svg": "615a",
	"./classificationIcons/נושא.svg": "453c",
	"./clear_search.svg": "2492",
	"./close_icon.svg": "6d7f",
	"./close_icon_white.svg": "eec5",
	"./cloud.svg": "9853",
	"./code.svg": "2186",
	"./computer_upload_icon.svg": "842d",
	"./content_type_icon.svg": "806a",
	"./docs_upload_icon.svg": "e891",
	"./download_icon.svg": "13ec",
	"./download_icon_black.svg": "7644",
	"./drop_arrow.svg": "ec5b",
	"./edit-dark-gray.svg": "36d1",
	"./edit_icon.svg": "a96a",
	"./edit_icon_ltr.svg": "510c",
	"./empty-195 (1).svg": "3616",
	"./exit_icon.svg": "8e15",
	"./eye_show_password.svg": "430e",
	"./eye_show_password_hide.svg": "8e52",
	"./facebook_icon.svg": "8eb0",
	"./feedback_icon.svg": "5cb1",
	"./file.svg": "002a",
	"./fileTypeIcons/classe.svg": "f545",
	"./fileTypeIcons/docx.svg": "72a5",
	"./fileTypeIcons/file.svg": "5722",
	"./fileTypeIcons/link_upload.svg": "ab08",
	"./fileTypeIcons/pdf.svg": "967e",
	"./fileTypeIcons/photo.svg": "6dab",
	"./fileTypeIcons/pptx.svg": "5975",
	"./fileTypeIcons/video_file_upload.svg": "c0a2",
	"./fileTypeIcons/xlsx.svg": "bec4",
	"./fileTypeIcons/youtube.svg": "01f0",
	"./google-icon.svg": "f9b0",
	"./google_drive_logo.svg": "4b98",
	"./grade_icon.svg": "b17f",
	"./link_icon.svg": "751d",
	"./link_upload_icon.svg": "0677",
	"./lock.svg": "d3cc",
	"./lock_icon.svg": "7e56",
	"./logo_classe_blue.svg": "9f7e",
	"./logo_classe_grey.svg": "95ab",
	"./mail_icon.svg": "6026",
	"./menu_arrow.svg": "251f",
	"./no-content.svg": "e47d",
	"./no_units_icon.svg": "99c8",
	"./open_new_tab_black.svg": "7930",
	"./page_config_icon.svg": "7af0",
	"./pen.svg": "800f",
	"./permission_denied.svg": "6a2f",
	"./preview_icon.svg": "af2c",
	"./products_hover_icon.svg": "2d15",
	"./products_icon.svg": "a241",
	"./red_trash_icon.svg": "6868",
	"./reports_icon.svg": "3ca1",
	"./return_arrow_icon.svg": "ea28",
	"./return_icon.svg": "6bf4",
	"./search_grey_icon.svg": "f396",
	"./search_icon.svg": "2fe9",
	"./send-green-big.svg": "4a1b",
	"./send-green-small.svg": "d45c",
	"./send-white.svg": "8060",
	"./siman-kriya-green.svg": "c3f1",
	"./siman-kriya-red.svg": "6c02",
	"./small-arrow.svg": "a9a4",
	"./sound-blue-ltr.svg": "eb74",
	"./sound-blue.svg": "4c95",
	"./sound.svg": "00f5",
	"./sound_ltr.svg": "adae",
	"./team-panel/arrow-no-content.svg": "54df",
	"./team-panel/csv_file_icon.svg": "e716",
	"./team-panel/delete_file.svg": "a035",
	"./team-panel/filter.svg": "20d8",
	"./team-panel/filter_active.svg": "52cc",
	"./team-panel/info.svg": "6909",
	"./team-panel/paper_icon.svg": "30e8",
	"./team-panel/person.svg": "6bbb",
	"./team-panel/reload_again_icon.svg": "93c4",
	"./team-panel/sidebar/baseLibrary.svg": "9b14",
	"./team-panel/sidebar/contentApproval.svg": "ba43",
	"./team-panel/sidebar/staffList.svg": "605f",
	"./team-panel/sort.svg": "df88",
	"./team-panel/sort_active.svg": "d783",
	"./team-panel/warning_red_icon.svg": "4827",
	"./trash_body.svg": "42d3",
	"./trash_cover.svg": "c188",
	"./trash_icon.svg": "4b64",
	"./twitter_icon.svg": "a7bc",
	"./unauthorized.svg": "cb5f",
	"./units_to_aprove_icon.svg": "9a190",
	"./upload-arrow.svg": "1cee",
	"./upload_icon.svg": "a15b",
	"./upload_icon_grey.svg": "ebc4",
	"./upload_image_btn.svg": "a940",
	"./upload_white_arrow.svg": "9b29",
	"./url.svg": "cdf8",
	"./user.svg": "c9d8",
	"./user_blue_icon.svg": "bab0",
	"./user_grey_dark_icon.svg": "88d4",
	"./v-icon.svg": "8b57",
	"./vi-green.svg": "cb28",
	"./video.svg": "b5ee",
	"./video_file_upload.svg": "21c2",
	"./video_ltr.svg": "c970",
	"./video_upload_icon.svg": "c505",
	"./whatsapp_icon.svg": "3477",
	"./white_arrow.svg": "2c6c",
	"./world.svg": "c8c2",
	"./x-red.svg": "e7f8",
	"./x_white.svg": "fb46",
	"./youtube_file_icon.svg": "e1bc",
	"./youtube_video.svg": "429d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";